import { createLogger } from "../../utils";
import { PageType } from "../dataLayer";
const logger = createLogger("article-meta");
async function requestArticleMetadata(context) {
    const dl = context.services.dataLayerService?.dataLayer;
    const cid = dl?.cid;
    // For use with validate
    // const pageType = dl?.validate === true ? PageType.Article : dl?.pageType;
    const pageType = dl?.pageType;
    const locationHref = dl?.locationHref;
    const issueDate = dl?.issueDate;
    const metaApiService = context.services?.metaApiService;
    if (!metaApiService) {
        logger.logInfo("Meta-API service not available");
    }
    if (pageType !== PageType.Article) {
        logger.logInfo(`Page type incompatible with meta data`);
    }
    if (!cid) {
        logger.logInfo(`No content id available for meta data`);
    }
    if (!locationHref) {
        logger.logInfo(`No location href available for meta data`);
    }
    if (!issueDate) {
        logger.logInfo(`No issueDate available for meta data`);
    }
    if (metaApiService &&
        pageType === PageType.Article &&
        cid &&
        locationHref &&
        issueDate) {
        try {
            logger.logInfo(`Requesting metadata for article ${cid}`);
            const meta = await metaApiService?.getMetadata(cid.toString(), locationHref.toString(), issueDate.toString());
            if (meta) {
                return meta;
            }
        }
        catch (e) {
            logger.logError(`Unable to get meta data: ${e}`);
        }
    }
    return undefined;
}
export default requestArticleMetadata;
//# sourceMappingURL=article-meta.js.map